<template>
  <div>
    <v-card-subtitle class="subtitle-1 pb-0 font-weight-bold">
      Contained Metals
    </v-card-subtitle>
    <div
      v-for="(lot, index) in shipmentSummaries"
      :key="index"
    >
      <div v-if="shipmentSummaries.length > 1">
        <b class="ml-3 mt-5">{{ `Lot ${lot.internal_lot_id}` }}</b>
        <v-divider class="ma-2" />
      </div>
      <v-row>
        <v-col>
          <card-list-item
            title="PT Troy Ounces"
            no-cols
          >
            {{ lot.contained_pt_toz | toFixed(3) | filterZero | appendCtoz }}
          </card-list-item>
        </v-col>
        <v-col>
          <card-list-item
            title="PD Troy Ounces"
            no-cols
          >
            {{ lot.contained_pd_toz | toFixed(3) | filterZero | appendCtoz }}
          </card-list-item>
        </v-col>
        <v-col>
          <card-list-item
            title="RH Troy Ounces"
            no-cols
          >
            {{ lot.contained_rh_toz | toFixed(3) | filterZero | appendCtoz }}
          </card-list-item>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ContainedMetals',
  props: {
    shipmentSummaries: {
      type: Array,
      required: true
    }
  }
}
</script>
